module.exports = __webpack_public_path__ + "static/media/jsoneditor-icons.15f2789d.svg";